(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gw-camopants-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gallery = document.querySelector('[data-gw-pants-gallery]');
    if (!gallery) return;

    const track = gallery.querySelector('.gw-pants-product__track');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gw-pants-thumb]'));
    const slides = Array.from(gallery.querySelectorAll('[data-gw-pants-open]'));
    const prev = gallery.querySelector('.gw-pants-product__arrow--prev');
    const next = gallery.querySelector('.gw-pants-product__arrow--next');
    const lightbox = document.querySelector('[data-gw-pants-lightbox]');
    const lightboxTrack = lightbox?.querySelector('.gw-pants-lightbox__track');
    const close = lightbox?.querySelector('[data-gw-pants-close]');
    const lightboxPrev = lightbox?.querySelector('[data-gw-pants-lightbox-prev]');
    const lightboxNext = lightbox?.querySelector('[data-gw-pants-lightbox-next]');
    const form = document.querySelector('[data-gw-pants-form]');
    const variantInput = form?.querySelector('[data-gw-pants-variant-input]');
    const sizeButtons = Array.from(form?.querySelectorAll('[data-gw-pants-variant]') || []);
    let index = 0;
    let lightboxIndex = 0;

    const setActive = (nextIndex) => {
      if (!slides.length || !track) return;
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
    };

    const setLightbox = (nextIndex) => {
      if (!slides.length || !lightboxTrack) return;
      lightboxIndex = (nextIndex + slides.length) % slides.length;
      lightboxTrack.style.transform = `translateX(-${lightboxIndex * 100}%)`;
    };

    const openLightbox = (startIndex) => {
      if (!lightbox || !lightboxTrack) return;
      lightboxTrack.innerHTML = slides.map((slide) => {
        const image = slide.querySelector('img');
        return image ? `<img src="${image.currentSrc || image.src}" alt="${image.alt}">` : '';
      }).join('');
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      setLightbox(startIndex);
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.addEventListener('click', () => setActive(thumbIndex));
    });
    slides.forEach((slide, slideIndex) => {
      slide.addEventListener('click', () => openLightbox(slideIndex));
    });
    prev?.addEventListener('click', () => setActive(index - 1));
    next?.addEventListener('click', () => setActive(index + 1));
    close?.addEventListener('click', closeLightbox);
    lightboxPrev?.addEventListener('click', () => setLightbox(lightboxIndex - 1));
    lightboxNext?.addEventListener('click', () => setLightbox(lightboxIndex + 1));
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox?.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
    document.addEventListener('keydown', (event) => {
      if (!lightbox?.open) return;
      if (event.key === 'ArrowLeft') setLightbox(lightboxIndex - 1);
      if (event.key === 'ArrowRight') setLightbox(lightboxIndex + 1);
    });

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled || !variantInput) return;
        variantInput.value = button.dataset.gwPantsVariant;
        sizeButtons.forEach((sizeButton) => {
          const isActive = sizeButton === button;
          sizeButton.classList.toggle('is-active', isActive);
          sizeButton.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-camoshorts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gallery = document.querySelector('[data-gw-shorts-gallery]');
    if (!gallery) return;

    const track = gallery.querySelector('.gw-shorts-product__track');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gw-shorts-thumb]'));
    const slides = Array.from(gallery.querySelectorAll('[data-gw-shorts-open]'));
    const prev = gallery.querySelector('.gw-shorts-product__arrow--prev');
    const next = gallery.querySelector('.gw-shorts-product__arrow--next');
    const lightbox = document.querySelector('[data-gw-shorts-lightbox]');
    const lightboxTrack = lightbox?.querySelector('.gw-shorts-lightbox__track');
    const close = lightbox?.querySelector('[data-gw-shorts-close]');
    const lightboxPrev = lightbox?.querySelector('[data-gw-shorts-lightbox-prev]');
    const lightboxNext = lightbox?.querySelector('[data-gw-shorts-lightbox-next]');
    const form = document.querySelector('[data-gw-shorts-form]');
    const variantInput = form?.querySelector('[data-gw-shorts-variant-input]');
    const sizeButtons = Array.from(form?.querySelectorAll('[data-gw-shorts-variant]') || []);
    let index = 0;
    let lightboxIndex = 0;

    const setActive = (nextIndex) => {
      if (!slides.length || !track) return;
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
    };

    const setLightbox = (nextIndex) => {
      if (!slides.length || !lightboxTrack) return;
      lightboxIndex = (nextIndex + slides.length) % slides.length;
      lightboxTrack.style.transform = `translateX(-${lightboxIndex * 100}%)`;
    };

    const openLightbox = (startIndex) => {
      if (!lightbox || !lightboxTrack) return;
      lightboxTrack.innerHTML = slides.map((slide) => {
        const image = slide.querySelector('img');
        return image ? `<img src="${image.currentSrc || image.src}" alt="${image.alt}">` : '';
      }).join('');
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      setLightbox(startIndex);
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.addEventListener('click', () => setActive(thumbIndex));
    });
    slides.forEach((slide, slideIndex) => {
      slide.addEventListener('click', () => openLightbox(slideIndex));
    });
    prev?.addEventListener('click', () => setActive(index - 1));
    next?.addEventListener('click', () => setActive(index + 1));
    close?.addEventListener('click', closeLightbox);
    lightboxPrev?.addEventListener('click', () => setLightbox(lightboxIndex - 1));
    lightboxNext?.addEventListener('click', () => setLightbox(lightboxIndex + 1));
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox?.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
    document.addEventListener('keydown', (event) => {
      if (!lightbox?.open) return;
      if (event.key === 'ArrowLeft') setLightbox(lightboxIndex - 1);
      if (event.key === 'ArrowRight') setLightbox(lightboxIndex + 1);
    });

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled || !variantInput) return;
        variantInput.value = button.dataset.gwShortsVariant;
        sizeButtons.forEach((sizeButton) => {
          const isActive = sizeButton === button;
          sizeButton.classList.toggle('is-active', isActive);
          sizeButton.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
